import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "position-absolute d-flex",
  style: {"justify-content":"center","align-items":"center","height":"100vh","width":"100%","background-color":"rgba(0, 0, 0, 0.8)","z-index":"2"}
}
const _hoisted_2 = {
  key: 0,
  class: "timeContainer bg-primary",
  style: {"overflow-y":"auto"}
}
const _hoisted_3 = { style: {"font-size":"64px"} }
const _hoisted_4 = { style: {"display":"flex","justify-content":"space-between","width":"100%"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", null, "Add +2", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", null, "Add DNF", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", null, "Remove time", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", null, "Exit", -1)

import { type Time } from "@/js/types";

export default /*#__PURE__*/_defineComponent({
  __name: 'ModifyTime',
  props: ["time"],
  emits: ["modifyTime", "exit-time-modifying"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
let navigator = window.navigator;

function getDateString(date: Date): string {
    //* time hh:mm
    let hours: string = date.getHours().toString(); /* hours */
    hours.length == 1 ? (hours = "0" + hours) : null;
    let minutes: string = date.getMinutes().toString(); /* minutes */
    minutes.length == 1 ? (minutes = "0" + minutes) : null;

    //* day dd/mm/yyyy
    let days = date.getDate(); /* day */
    let months = date.getMonth() + 1; /* month */
    let year = date.getFullYear(); /* year */
    return `${hours}:${minutes} ${days}/${months}/${year}`;
}

function makeShortScrambleText(scramble: string): string {
    let scrambleArr: string[] = scramble.split(" ");
    scrambleArr = scrambleArr.filter((e) => {
        if (e == "" || e == " ") {
            return false;
        }
        return true;
    });
    if (scrambleArr.length <= 15) {
        return scrambleArr.join(" ");
    }
    let scrambleArrFiltered: string[] = scrambleArr.filter((_e, index) => {
        if (index > 15) {
            return false;
        }
        return true;
    });
    let shortScrambleText: string = scrambleArrFiltered.join(" ") + "...";
    return shortScrambleText;
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (props.time != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(props.time.str), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_btn, {
                style: {"width":"150px"},
                color: "background",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('modifyTime', ['plus2', __props.time])))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                style: {"width":"150px"},
                color: "background",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('modifyTime', ['dnf', __props.time])))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                style: {"width":"150px"},
                color: "background",
                onClick: _cache[2] || (_cache[2] = ($event: any) => {
                            emit('modifyTime', ['remove', __props.time]);
                            emit('exit-time-modifying');
                        })
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_v_divider, {
              class: "my-3",
              thickness: 3,
              length: "90%"
            }),
            _createElementVNode("p", {
              class: "hoverUnderline",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(navigator).clipboard.writeText(props.time.scramble)))
            }, "Scramble: " + _toDisplayString(makeShortScrambleText(props.time.scramble)), 1),
            _createElementVNode("p", null, "Date: " + _toDisplayString(getDateString(new Date(props.time.date))), 1),
            _createVNode(_component_v_divider, {
              class: "my-3",
              thickness: 3,
              length: "90%"
            }),
            _createVNode(_component_v_btn, {
              style: {"width":"400px"},
              color: "background",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('exit-time-modifying')))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})